import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import { configureStore } from '@eb/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eb/site-analytics';

import reducer from '../SearchApp/reducers';
import { getInitialData } from '../SearchApp/reducers/utils';
import BrowsePage from './BrowsePage';

import '../SearchApp/app.scss';

export default class BrowsePageWithStore extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    render() {
        return (
            <Provider store={this._store}>
                <BrowsePage {...this.props} />
            </Provider>
        );
    }
}
